interface Props {
  lastSeen: number
}

function formatAgo(ts: number): string {
  const diff = Math.floor((Date.now() - ts) / 1000)
  if (diff < 60) return `${diff}s ago`
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`
  return `${Math.floor(diff / 3600)}h ago`
}

export function OfflineBanner({ lastSeen }: Props) {
  return (
    <div className="bg-warn/20 border-y border-warn/40 text-warn px-4 py-3 text-sm font-medium">
      ⚠ Router unreachable — Last seen {formatAgo(lastSeen)}. Takes are disabled.
    </div>
  )
}
